<script>
    import Layout from "../../layouts/main";
    import appConfig from "@/app.config";   
    import apigeneric from "@/helpers/apigeneric";
    import Loader from "@/components/widgets/loader";
    import Banner from "../components/banner";
    
    export default {
      page: {
        title: process.env.VUE_APP_NAME,
        meta: [
          {
            name: "description",
            content: appConfig.description,
          },
        ],
      },
      components: {
        Layout,
        Loader,
        Banner
    
      },
      mixins: [ apigeneric],
      data() {
        return {
          DefaultPage: 1,
          ActivitiesData: {},
            Page: {
            PageNumber: 1,
            PageSize: 10,
            PageDataSize: 1,
          },
          title: this.$t('StrAnasayfa.Title'),
          NewsData:{},
          ActivitiesTitle: {},
          ActivitiesTitleDescription: {},
          ReadMoreValue: {},
          LangId: this.$route.params.LangId,
          items: [
             
            {
              text: this.$t('StrAnasayfa.Title'),
              active: true,
            },
          ],  
          fetchingStats: true,  
        };
      }, 
      methods: { 
        Get(){
          if(this.LangId=="tr"){
            this.ActionsGet({
            Service: "activities",
            Page: this.Page,
          }).then((res) => {
            this.ActivitiesData = res.Data; 
                  this.Page.PageDataSize = res.TotalCount;
          });
        }else{
          this.ActionsFilterGet({
            Service: "languages",
            Page: this.Page,
            Filter:
           "&shortlangtitle="+this.LangId
          }).then((res) => {
            for( let LangData in res.Data){
              this.ActionsFilterGet({
            Service: "activitytranslations",
            Page: this.Page,
            Filter: "&Langid="+ res.Data[LangData].Id
          }).then((res) => {
            this.ActivitiesData = res.Data;
            this.Page.PageDataSize = res.TotalCount;
            if(res.TotalCount == 0){
              localStorage.setItem("lang", "tr");
              window.location.reload();
              
            }
            
            
          });
             }
            
          });
         
        }
        this.ActionsFilterGet({
        Service: "languages",
        Page: this.Page,
        Filter:
          "&shortlangtitle=" + this.LangId
      }).then((res) => {
        for (let LangData in res.Data) {
          this.ActionsFilterGet({
            Service: "LanguagereSources",
            Page: this.Page,
            Filter: "&Langid=" + res.Data[LangData].Id + "&Resourceid=9c0688d8-02a8-4e54-bf39-bc8d5cdeb75f"
          }).then((res) => {
            this.ActivitiesTitle = res.Data;
            if (res.TotalCount == 0) {
              localStorage.setItem("lang", "tr");
              window.location.reload();
            }
          });
        }
      });

      this.ActionsFilterGet({
        Service: "languages",
        Page: this.Page,
        Filter:
          "&shortlangtitle=" + this.LangId
      }).then((res) => {
        for (let LangData in res.Data) {
          this.ActionsFilterGet({
            Service: "LanguagereSources",
            Page: this.Page,
            Filter: "&Langid=" + res.Data[LangData].Id + "&Resourceid=f2e143f5-770b-4811-a548-ac7c15285470"
          }).then((res) => {
            this.ActivitiesTitleDescription = res.Data;
            if (res.TotalCount == 0) {
              localStorage.setItem("lang", "tr");
              window.location.reload();
            }
          });
        }
      });

      this.ActionsFilterGet({
        Service: "languages",
        Page: this.Page,
        Filter:
          "&shortlangtitle=" + this.LangId
      }).then((res) => {
        for (let LangData in res.Data) {
          this.ActionsFilterGet({
            Service: "LanguagereSources",
            Page: this.Page,
            Filter: "&Langid=" + res.Data[LangData].Id + "&Resourceid=878b315b-fa05-41b1-9cc5-4c480effbf65"
          }).then((res) => {
            this.ReadMoreValue = res.Data;
            if (res.TotalCount == 0) {
              localStorage.setItem("lang", "tr");
              window.location.reload();
            }
          });
        }
      });
    
        }
      },
    };
    </script>
    
    <template>
     <Loader>
      <Layout> 
          <Banner />
         
    <section>
            <div class="home-news">
                <div class="title c-flex flex-column">
                    <h3>{{ActivitiesTitle[0].Resourcevalue}}</h3>
                    <p>{{ActivitiesTitleDescription[0].Resourcevalue}}</p> 
                </div> 
                <div class="container">
                        <div class="row">
                              <div
                class="col-md-4 c-flex"
                v-for="(Data, index) in ActivitiesData" 
                :key="index"
              >
                <div class="card col-md-12">
                  <img
                    :src="$config.FILES_URL + 'web/' + Data.Imagegallery"
                    class="card-img-top"
                    alt=""
                  />
                  <div class="card-body">
                    <h5 class="card-date">{{ Data.Startdate | formatDateTime }}</h5>
                    <h5 class="card-title mt-3">
                      {{ Data.Title }}
                    </h5>
                    <p class="card-text">
                      <span v-html="Data.Description"></span><br/>
                    </p>
                    <a :href="'/activitydetails/' + LangId + '/'+ Data.Title.toLowerCase()
                                    .replace(/I|İ/gi, 'i')
                                    .replace(/Ğ|ğ/gi, 'g')
                                    .replace(/Ç|ç|ğ/gi, 'c')
                                    .replace(/\s+/g, '-')
                                    .replace(/&/g, `-and-`)
                                    .replace(/--/g, `-`) + '/' + Data.Id" class="card-link"
                      >{{ReadMoreValue[0].Resourcevalue}} →</a
                    >
                   
                  </div>
                </div>
              </div>
                          </div>
                </div>
               <b-pagination
  class="pagination pagination-rounded justify-content-end mb-2"
  v-model="DefaultPage"
  :total-rows="Number(Page.PageDataSize)" 
  :per-page="Number(Page.PageSize)"
  @input="ChangePage"
>
</b-pagination>
            </div>
        </section>
    
    
    
         
      
      </Layout>
      </Loader>
    </template>
    